import { axios } from '@/services/axios';

export const createLocation = (locationData) => {
    return axios.post('/trunklocation/', locationData);
};
